import { PopupReturnTypeWithPayload } from '../../../hooks/usePopup'
import { TContractCategoriesList } from '../types'
import { initialPopup } from '../../../hooks/constants'

export const defaultPopupWithPayload: PopupReturnTypeWithPayload<{
  selectedCC: TContractCategoriesList
}> = {
  state: {
    ...initialPopup?.state,
    payload: { selectedCC: {} as TContractCategoriesList }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}
